import styled from "styled-components";
import { colors, devices, margins, sizes } from "../../../utils/styled";
import { overlayCardStyle } from "../Cards/overlayCard.style";
import { sectionStyle, titleStyle } from "../style";

export const RelatedSliderContainer = styled.section`
	${overlayCardStyle}
	${sectionStyle}
	background-color: ${colors.bluegray};

	> .rel-content__section__items {
		transform: translate(50%, 0);
		transition: transform 0.6s ease-out;

		&.animated {
			transform: translate(0, 0);

			.slick-slide {
				animation-name: cards;
				animation-duration: 0.6s;
				animation-timing-function: ease-out;
				animation-fill-mode: forwards;

				${props => {
					let animation = `
						&:first-child { animation-delay: 0s; }
					`
					for (let i = 1; i <= props.numberSlides; i++) animation = animation + `
						&:nth-child(${i}) { animation-delay: ${(i - 1) * 0.1}s; }
					`
					return animation;
				}} @keyframes cards {
				0% {
					transform: translateX(50%);
				}

				to {
					transform: translateX(0);
					opacity: 1;
				}
			}
			}
		}

		@media ${devices.tablets} {
			margin-top: 28px;
		}

		@media ${devices.desktop} {
			margin-top: 33px;
		}

		.rel-content__card--overlay {
			&:hover {
				.rel-content__card--overlay__slider {
					background-color: ${colors.limeGreen};

					& .rel-content__card--overlay__header {
						background-color: ${colors.limeGreen};
					}

					& .rel-content__card--overlay__date {
						display: none;
					}

					& .rel-content__card--overlay__tag {
						transform: translateY(-45px);
						background-color: transparent;
					}

					& .rel-content__card--overlay__body {
						background-color: ${colors.limeGreen};

						& .rel-content__card--overlay__title {
							transform: translateY(-45px);
							background-color: ${colors.limeGreen};
							height: unset;
						}

						& .rel-content__card--overlay__description {
							background-color: ${colors.limeGreen};
							display: none;
						}

						& .rel-content__card--overlay__link {
							background-color: ${colors.limeGreen};
							bottom: 40px;
						}
					}

				}

				.rel-content__card--overlay__bgimg {
					&:before {
						background-color: ${colors.limeGreen};
						background-image: unset;
						opacity: 1;
					}
				}

			}

			.rel-content__card--overlay__body{
				opacity: 1;
			}

			& .rel-content__card--overlay__date {
				display: none;
			}

			.rel-content__card--overlay__bgimg {
				height: 300px;
				position: relative;

				img {
					object-fit: cover;
				}

				&.rel-content__card--overlay__fitted-img {
					padding: 30px;

					img {
						object-fit: contain;
					}

					&:before {
						background-image: unset;
					}
				}
			}

			.rel-content__card {
				&--overlay__slider {
					position: relative;
					height: 130px;
					background-color: ${colors.white};
					justify-content: center;
					gap: 2px;
					top: 0;
					bottom: 0;
					left: 0;
					right: 0;

					.rel-content__card {
						&--overlay__header {
							background-color: ${colors.white};
							margin-right: 27px;
							margin-left: 27px;
						}

						&--overlay__body {
							background-color: ${colors.white};
							margin-right: 27px;
							margin-left: 27px;
						}

						&--overlay__tag {
							transition: transform 500ms ease;
							font-family: "Aeonik Mono", monospace;
							font-weight: 400;
							font-size: 12px;
							line-height: 120%;
							letter-spacing: 3;
							color: ${colors.bluegray};
							border: unset;
							padding: 0;
						}

						&--overlay__title {
							transition: transform 500ms ease;
							font-family: "Aeonik Pro", "infios", Arial, sans-serif;
							display: flex;
							align-items: center;
							height: 100%;

							h3 {
								color: ${colors.bluegray};
								font-size: 26px;
								line-height: 100%;
								font-weight: 500;
							}
						}

						&--overlay__link {
							font-size: 19px;
							display: flex;
							align-items: center;
							gap: 10px;
							padding: 0;
							color: ${colors.bluegray};
							position: absolute;
							bottom: -25px;
							transition: bottom 700ms ease;

							svg {
								width: 12px;
								path {
									fill: ${colors.bluegray};
									transition: fill 500ms ease;
								}
							}
						}

						&--overlay__description {
							transform: unset;
							transition: unset;
						}
					}


				}

			}
		}

		.slick-slider {
			width: 100%;

			.slick-dots {
				display: none !important;
			}

			.slick-list {
				overflow: visible;

				.slick-track {
					display: flex;
					justify-content: flex-start;
					flex-shrink: 0;

					& > * {
						margin-right: 32px;

						@media ${devices.tablets} {
							margin-right: 24px;
						}

						@media ${devices.mobile} {
							margin-right: 16px;
						}
					}

					& > *:last-child {
						margin-right: 0;
					}
				}
			}
		}

	}

	> .rel-content__section__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 24px;

		> .rel-content__section__title {
			${titleStyle}
			h2,.rel-content__section__subtitle {
				color: ${colors.white};
			}
		}

		> .rel-content__section__navigation {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 32px;

			@media ${devices.mobile} {
				display: none;
			}

			.rel-content__section__navigation__button {
				height: 28px;
				cursor: pointer;

				&:first-child {
					svg {
						transform: rotate(180deg);
						transform-origin: center
					}
				}

				svg {
					path {
						fill: ${colors.lemon};
					}

					width: 37px;
					height: 42px;
				}

				&:hover {
					svg {
						path {
							stroke: ${colors.bluegray};
							fill: ${colors.lemon};
						}
					}
				}

				&.disabled {
					opacity: 0.5;
					cursor: auto;
					pointer-events: none;
				}
			}
		}
	}

	.slider__progress {
		height: 1px;
		max-width: unset;

		@media ${devices.mobile} {
			display: none;
		}

		.slider__progress__wrapper {
			max-width: 1512px;
			width: 100%;
			margin: 0 auto;

			.slider__progress__marker {
				top: -1px;
				height: 3px;
				background-color: ${colors.lemon};
				transition: left 300ms ease;
				margin-left: ${props => `${((1 / props.totalScrolls) * 100) * (props.currentSlide)}%`};
				font-size: ${props => props.currentSlide}px;
				width: ${props => `${(1 / props.totalScrolls) * 100}%`};
			}
		}
	}
`;

export const RelatedSliderCard = styled.div`
	.rel-content__card--overlay {
		background-color: ${props => props.imageBackgroundColor || colors.platinum};
	}
`
